export default __webpack_public_path__ + "static/media/compliance-white.81f3867e.svg";